module.exports = __webpack_public_path__ + "static/img/075.8fdf3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/075.png
// module id = VInR
// module chunks = 0